/**
 * Generate page numbers for pagination buttons
 */
export function generatePageNumbers(
  currentPage: number,
  totalPages: number,
  maxButtons: number = 5
): number[] {
  if (totalPages === 0) return [];

  const maxButtonsToShow = Math.min(totalPages, maxButtons);
  const pages: number[] = [];

  for (let i = 0; i < maxButtonsToShow; i++) {
    let pageNum: number;

    if (totalPages <= maxButtons) {
      pageNum = i + 1;
    } else if (currentPage <= 3) {
      pageNum = i + 1;
    } else if (currentPage >= totalPages - 2) {
      pageNum = totalPages - maxButtons + 1 + i;
    } else {
      pageNum = currentPage - 2 + i;
    }

    pages.push(pageNum);
  }

  return pages;
}
